var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { m as messages, e as en } from "./index-38c53cf2.mjs";
import { i as i18n$1, b as boundUseI18n } from "./_i18n-e414d464.mjs";
import { computed, ref } from "vue";
import "./index-64135f7d.mjs";
import "./malarkeyTwilioAdapter-1c296255.mjs";
import "./event-socket/malarkeyEventSocketAdapter.es.js";
import { d as debug } from "./_debug-8b5c3032.mjs";
import "./otpauth.esm-675c01d0.mjs";
import "./sudo-bad5b55e.mjs";
import { d as dot } from "./index-fd2245c5.mjs";
function findByGenerator(array, key, insensensative = false) {
  return (value) => array.find(
    (item) => insensensative && typeof item[key] === "string" && typeof value === "string" ? item[key].toString().trim().toLowerCase() === value.toString().trim().toLowerCase() : item[key] === value
  );
}
class MalarkeyLanguageInstance {
  /**
   * Create an instance of the MalarkeyLanguage class.
   * @param input The object defining the language.
   * @private
   */
  constructor(language2) {
    /**
     * The iso2 language code
     */
    __publicField(this, "iso2");
    /**
     * The iso3 language code
     */
    __publicField(this, "iso3");
    /**
     * The name of the language in English
     */
    __publicField(this, "name");
    /**
     * The name of the language in the local language
     */
    __publicField(this, "local");
    /**
     * Whether the language is right-to-left
     */
    __publicField(this, "rtl");
    this.iso2 = language2.iso2;
    this.iso3 = language2.iso3;
    this.name = language2.name;
    this.local = language2.local;
    this.rtl = language2.rtl;
  }
}
const languages = [
  {
    iso2: "en",
    iso3: "enu",
    name: "English",
    local: "English",
    rtl: false
  },
  {
    iso2: "he",
    iso3: "heb",
    name: "Hebrew",
    local: "עברית",
    rtl: true
  },
  {
    iso2: "ru",
    iso3: "rus",
    name: "Russian",
    local: "русский",
    rtl: false
  },
  {
    iso2: "af",
    iso3: "afr",
    name: "Afrikaans",
    local: "Afrikaans",
    rtl: false
  },
  {
    iso2: "sq",
    iso3: "alb",
    name: "Albanian",
    local: "Shqip",
    rtl: false
  },
  {
    iso2: "am",
    iso3: "amh",
    name: "Amharic",
    local: "አማርኛ",
    rtl: false
  },
  {
    iso2: "ar",
    iso3: "ara",
    name: "Arabic",
    local: "العربية",
    rtl: true
  },
  {
    iso2: "an",
    iso3: "arg",
    name: "Aragonese",
    local: "aragonés",
    rtl: false
  },
  {
    iso2: "hy",
    iso3: "arm",
    name: "Armenian",
    local: "Հայերեն",
    rtl: false
  },
  {
    iso2: "as",
    iso3: "asm",
    name: "Assamese",
    local: "অসমীয়া",
    rtl: false
  },
  {
    iso2: "az",
    iso3: "aze",
    name: "Azerbaijani",
    local: "azərbaycan dili",
    rtl: false
  },
  {
    iso2: "ba",
    iso3: "bak",
    name: "Bashkir",
    local: "башҡорт теле",
    rtl: false
  },
  {
    iso2: "eu",
    iso3: "baq",
    name: "Basque",
    local: "euskara, euskera",
    rtl: false
  },
  {
    iso2: "be",
    iso3: "bel",
    name: "Belarusian",
    local: "беларуская мова",
    rtl: false
  },
  {
    iso2: "bn",
    iso3: "ben",
    name: "Bengali",
    local: "বাংলা",
    rtl: false
  },
  {
    iso2: "bs",
    iso3: "bos",
    name: "Bosnian",
    local: "bosanski jezik",
    rtl: false
  },
  {
    iso2: "br",
    iso3: "bre",
    name: "Breton",
    local: "brezhoneg",
    rtl: false
  },
  {
    iso2: "bg",
    iso3: "bul",
    name: "Bulgarian",
    local: "български език",
    rtl: false
  },
  {
    iso2: "ca",
    iso3: "cat",
    name: "Catalan",
    local: "català",
    rtl: false
  },
  {
    iso2: "zh",
    iso3: "chi",
    name: "Chinese",
    local: "中文",
    rtl: false
  },
  {
    iso2: "co",
    iso3: "cos",
    name: "Corsican",
    local: "corsu",
    rtl: false
  },
  {
    iso2: "hr",
    iso3: "hrv",
    name: "Croatian",
    local: "hrvatski jezik",
    rtl: false
  },
  {
    iso2: "cs",
    iso3: "cze",
    name: "Czech",
    local: "čeština",
    rtl: false
  },
  {
    iso2: "da",
    iso3: "dan",
    name: "Danish",
    local: "dansk",
    rtl: false
  },
  {
    iso2: "dv",
    iso3: "div",
    name: "Divehi",
    local: "ދިވެހި",
    rtl: true
  },
  {
    iso2: "nl",
    iso3: "nld",
    name: "Dutch",
    local: "Nederlands",
    rtl: false
  },
  {
    iso2: "et",
    iso3: "est",
    name: "Estonian",
    local: "eesti",
    rtl: false
  },
  {
    iso2: "fo",
    iso3: "fao",
    name: "Faroese",
    local: "føroyskt",
    rtl: false
  },
  {
    iso2: "fi",
    iso3: "fin",
    name: "Finnish",
    local: "suomi",
    rtl: false
  },
  {
    iso2: "fr",
    iso3: "fre",
    name: "French",
    local: "français",
    rtl: false
  },
  {
    iso2: "gl",
    iso3: "glg",
    name: "Galician",
    local: "Galego",
    rtl: false
  },
  {
    iso2: "ka",
    iso3: "geo",
    name: "Georgian",
    local: "ქართული",
    rtl: false
  },
  {
    iso2: "de",
    iso3: "ger",
    name: "German",
    local: "Deutsch",
    rtl: false
  },
  {
    iso2: "el",
    iso3: "gre",
    name: "Greek",
    local: "ελληνικά",
    rtl: false
  },
  {
    iso2: "gu",
    iso3: "guj",
    name: "Gujarati",
    local: "ગુજરાતી",
    rtl: false
  },
  {
    iso2: "ha",
    iso3: "hau",
    name: "Hausa",
    local: "هَوُسَ",
    rtl: false
  },
  {
    iso2: "hi",
    iso3: "hin",
    name: "Hindi",
    local: "हिन्दी",
    rtl: false
  },
  {
    iso2: "hu",
    iso3: "hun",
    name: "Hungarian",
    local: "magyar",
    rtl: false
  },
  {
    iso2: "id",
    iso3: "ind",
    name: "Indonesian",
    local: "Bahasa Indonesia",
    rtl: false
  },
  {
    iso2: "ga",
    iso3: "gle",
    name: "Irish",
    local: "Gaeilge",
    rtl: false
  },
  {
    iso2: "ig",
    iso3: "ibo",
    name: "Igbo",
    local: "Asụsụ Igbo",
    rtl: false
  },
  {
    iso2: "is",
    iso3: "ice",
    name: "Icelandic",
    local: "Íslenska",
    rtl: false
  },
  {
    iso2: "it",
    iso3: "ita",
    name: "Italian",
    local: "Italiano",
    rtl: false
  },
  {
    iso2: "iu",
    iso3: "iku",
    name: "Inuktitut",
    local: "ᐃᓄᒃᑎᑐᑦ",
    rtl: false
  },
  {
    iso2: "kl",
    iso3: "kal",
    name: "Kalaallisut",
    local: "kalaallisut",
    rtl: false
  },
  {
    iso2: "kn",
    iso3: "kan",
    name: "Kannada",
    local: "ಕನ್ನಡ",
    rtl: false
  },
  {
    iso2: "kk",
    iso3: "kaz",
    name: "Kazakh",
    local: "қазақ тілі",
    rtl: false
  },
  {
    iso2: "km",
    iso3: "khm",
    name: "Khmer",
    local: "ខ្មែរ",
    rtl: false
  },
  {
    iso2: "rw",
    iso3: "kin",
    name: "Kinyarwanda",
    local: "Ikinyarwanda",
    rtl: false
  },
  {
    iso2: "ky",
    iso3: "kir",
    name: "Kyrgyz",
    local: "Кыргызча",
    rtl: false
  },
  {
    iso2: "ko",
    iso3: "kor",
    name: "Korean",
    local: "한국어",
    rtl: false
  },
  {
    iso2: "lb",
    iso3: "ltz",
    name: "Luxembourgish",
    local: "Lëtzebuergesch",
    rtl: false
  },
  {
    iso2: "lo",
    iso3: "lao",
    name: "Lao",
    local: "ພາສາລາວ",
    rtl: false
  },
  {
    iso2: "lt",
    iso3: "lit",
    name: "Lithuanian",
    local: "lietuvių kalba",
    rtl: false
  },
  {
    iso2: "lv",
    iso3: "lav",
    name: "Latvian",
    local: "latviešu valoda",
    rtl: false
  },
  {
    iso2: "mk",
    iso3: "mac",
    name: "Macedonian",
    local: "македонски јазик",
    rtl: false
  },
  {
    iso2: "ms",
    iso3: "may",
    name: "Malay",
    local: "Melayu",
    rtl: false
  },
  {
    iso2: "ml",
    iso3: "mal",
    name: "Malayalam",
    local: "മലയാളം",
    rtl: false
  },
  {
    iso2: "mt",
    iso3: "mlt",
    name: "Maltese",
    local: "Malti",
    rtl: false
  },
  {
    iso2: "mi",
    iso3: "mao",
    name: "Māori",
    local: "te reo Māori",
    rtl: false
  },
  {
    iso2: "mr",
    iso3: "mar",
    name: "Marathi",
    local: "मराठी",
    rtl: false
  },
  {
    iso2: "mn",
    iso3: "mon",
    name: "Mongolian",
    local: "Монгол хэл",
    rtl: false
  },
  {
    iso2: "nb",
    iso3: "nob",
    name: "Norwegian Bokmål",
    local: "Norsk Bokmål",
    rtl: false
  },
  {
    iso2: "ne",
    iso3: "nep",
    name: "Nepali",
    local: "नेपाली",
    rtl: false
  },
  {
    iso2: "nn",
    iso3: "nno",
    name: "Norwegian Nynorsk",
    local: "Norsk Nynorsk",
    rtl: false
  },
  {
    iso2: "no",
    iso3: "nor",
    name: "Norwegian",
    local: "Norsk",
    rtl: false
  },
  {
    iso2: "oc",
    iso3: "oci",
    name: "Occitan",
    local: "occitan",
    rtl: false
  },
  {
    iso2: "or",
    iso3: "ori",
    name: "Oriya",
    local: "ଓଡ଼ିଆ",
    rtl: false
  },
  {
    iso2: "pa",
    iso3: "pan",
    name: "Panjabi",
    local: "ਪੰਜਾਬੀ, پنجابی‎",
    rtl: false
  },
  {
    iso2: "fa",
    iso3: "per",
    name: "Persian",
    local: "فارسی",
    rtl: true
  },
  {
    iso2: "pl",
    iso3: "pol",
    name: "Polish",
    local: "język polski",
    rtl: false
  },
  {
    iso2: "ps",
    iso3: "pus",
    name: "Pashto",
    local: "پښتو",
    rtl: false
  },
  {
    iso2: "pt",
    iso3: "por",
    name: "Portuguese",
    local: "Português",
    rtl: false
  },
  {
    iso2: "qu",
    iso3: "que",
    name: "Quechua",
    local: "Runa Simi",
    rtl: false
  },
  {
    iso2: "rm",
    iso3: "roh",
    name: "Romansh",
    local: "Rumantsch Grischun",
    rtl: false
  },
  {
    iso2: "ro",
    iso3: "rum",
    name: "Romanian",
    local: "Română",
    rtl: false
  },
  {
    iso2: "sa",
    iso3: "san",
    name: "Sanskrit",
    local: "संस्कृतम्",
    rtl: false
  },
  {
    iso2: "se",
    iso3: "sme",
    name: "Northern Sami",
    local: "Davvisámegiella",
    rtl: false
  },
  {
    iso2: "sr",
    iso3: "srp",
    name: "Serbian",
    local: "српски језик",
    rtl: false
  },
  {
    iso2: "gd",
    iso3: "gla",
    name: "Scottish Gaelic",
    local: "Gàidhlig",
    rtl: false
  },
  {
    iso2: "si",
    iso3: "sin",
    name: "Sinhala, Sinhalese",
    local: "සිංහල",
    rtl: false
  },
  {
    iso2: "sk",
    iso3: "slo",
    name: "Slovak",
    local: "Slovenčina",
    rtl: false
  },
  {
    iso2: "sl",
    iso3: "slv",
    name: "Slovene",
    local: "Slovenski Jezik",
    rtl: false
  },
  {
    iso2: "st",
    iso3: "sot",
    name: "Southern Sotho",
    local: "Sesotho",
    rtl: false
  },
  {
    iso2: "es",
    iso3: "spa",
    name: "Spanish",
    local: "Español",
    rtl: false
  },
  {
    iso2: "sw",
    iso3: "swa",
    name: "Swahili",
    local: "Kiswahili",
    rtl: false
  },
  {
    iso2: "sv",
    iso3: "swe",
    name: "Swedish",
    local: "Svenska",
    rtl: false
  },
  {
    iso2: "ta",
    iso3: "tam",
    name: "Tamil",
    local: "தமிழ்",
    rtl: false
  },
  {
    iso2: "te",
    iso3: "tel",
    name: "Telugu",
    local: "తెలుగు",
    rtl: false
  },
  {
    iso2: "ja",
    iso3: "jpn",
    name: "Japanese",
    local: "日本語 (にほんご)",
    rtl: false
  },
  {
    iso2: "tg",
    iso3: "tgk",
    name: "Tajik",
    local: "тоҷикӣ",
    rtl: false
  },
  {
    iso2: "th",
    iso3: "tha",
    name: "Thai",
    local: "ไทย",
    rtl: false
  },
  {
    iso2: "bo",
    iso3: "tib",
    name: "Tibetan",
    local: "བོད་ཡིག",
    rtl: false
  },
  {
    iso2: "tk",
    iso3: "tuk",
    name: "Turkmen",
    local: "Türkmen",
    rtl: false
  },
  {
    iso2: "tn",
    iso3: "tsn",
    name: "Tswana",
    local: "Setswana",
    rtl: false
  },
  {
    iso2: "tr",
    iso3: "tur",
    name: "Turkish",
    local: "Türkçe",
    rtl: false
  },
  {
    iso2: "tt",
    iso3: "tat",
    name: "Tatar",
    local: "татар теле, tatar tele",
    rtl: false
  },
  {
    iso2: "ug",
    iso3: "uig",
    name: "Uyghur",
    local: "ئۇيغۇرچە",
    rtl: false
  },
  {
    iso2: "uk",
    iso3: "ukr",
    name: "Ukrainian",
    local: "Українська",
    rtl: false
  },
  {
    iso2: "ur",
    iso3: "urd",
    name: "Urdu",
    local: "اردو",
    rtl: true
  },
  {
    iso2: "uz",
    iso3: "uzb",
    name: "Uzbek",
    local: "Oʻzbek",
    rtl: false
  },
  {
    iso2: "vi",
    iso3: "vie",
    name: "Vietnamese",
    local: "Tiếng Việt",
    rtl: false
  },
  {
    iso2: "cy",
    iso3: "wel",
    name: "Welsh",
    local: "Cymraeg",
    rtl: false
  },
  {
    iso2: "wo",
    iso3: "wol",
    name: "Wolof",
    local: "Wollof",
    rtl: false
  },
  {
    iso2: "fy",
    iso3: "fry",
    name: "Western Frisian",
    local: "Frysk",
    rtl: false
  },
  {
    iso2: "xh",
    iso3: "xho",
    name: "Xhosa",
    local: "isiXhosa",
    rtl: false
  },
  {
    iso2: "yo",
    iso3: "yor",
    name: "Yoruba",
    local: "Yorùbá",
    rtl: false
  },
  {
    iso2: "zu",
    iso3: "zul",
    name: "Zulu",
    local: "isiZulu",
    rtl: false
  }
].map(
  (language2) => !(language2 instanceof MalarkeyLanguageInstance) ? new MalarkeyLanguageInstance(language2) : language2
);
const findLanguageByIso2$1 = findByGenerator(
  languages,
  "iso2",
  true
);
const findLanguageByIso3$1 = findByGenerator(
  languages,
  "iso3",
  true
);
const findLanguageByName = findByGenerator(
  languages,
  "name",
  true
);
const findLanguageByEnglishName$1 = findByGenerator(
  languages,
  "name",
  true
);
const findLanguageByLocalName$1 = findByGenerator(
  languages,
  "local",
  true
);
const _languages = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MalarkeyLanguageInstance,
  findLanguageByEnglishName: findLanguageByEnglishName$1,
  findLanguageByIso2: findLanguageByIso2$1,
  findLanguageByIso3: findLanguageByIso3$1,
  findLanguageByLocalName: findLanguageByLocalName$1,
  findLanguageByName,
  languages
}, Symbol.toStringTag, { value: "Module" }));
const findLanguageByIso2 = findLanguageByIso2$1;
const findLanguageByIso3 = findLanguageByIso3$1;
const findLanguageByEnglishName = findLanguageByEnglishName$1;
const findLanguageByLocalName = findLanguageByLocalName$1;
const list = computed(
  () => languages.filter((l) => Object.keys(messages).includes(l.iso2))
);
const language = computed(
  () => languages.find((l) => l.iso2 === i18n$1.global.locale.value)
);
const showSwitchPrompt = ref(false);
const bootToLocale = ref(void 0);
const i18nService = {
  findLanguageByIso2,
  findLanguageByIso3,
  findLanguageByEnglishName,
  findLanguageByLocalName,
  list,
  language,
  showSwitchPrompt
};
const setLocale = (app, locale) => {
  if (i18n$1.global.locale.value === locale) {
    return;
  }
  debug(`Setting locale to ${locale}`);
  i18n$1.global.locale.value = locale;
  app.config.globalProperties.$i18n.locale = locale;
  app.config.globalProperties.$ls.set("i18n", locale);
  app._instance.ctx.$vuetify.locale.current = locale;
  showSwitchPrompt.value = false;
  app.config.globalProperties.$bus.emit(
    "i18n:changed",
    {
      crossTab: true
    },
    locale
  );
};
const initI18n = (app) => {
  if (app.config.globalProperties.$lang) {
    debug("i18n lang service already initialized, skipping");
    return;
  }
  debug("Initializing i18n lang service");
  i18nService.setLocale = setLocale.bind(null, app);
  app.provide("lang", i18nService);
  app.config.globalProperties.$lang = i18nService;
  debug("i18n lang service initialized");
};
const doInitI18n = (app) => {
  if (!app.config.globalProperties.$ls) {
    debug("No LocalStorage service found, skipping i18n initialization");
    return;
  }
  if (bootToLocale.value) {
    showSwitchPrompt.value = false;
    setLocale(app, bootToLocale.value);
  }
  const fromLs = app.config.globalProperties.$ls.get("i18n");
  if (!fromLs) {
    debug("No i18n locale found in LocalStorage");
    showSwitchPrompt.value = true;
    return;
  }
  showSwitchPrompt.value = false;
  setLocale(app, fromLs);
};
const bootWithLocale = (locale) => {
  bootToLocale.value = locale;
};
const terms = dot.dot(en);
const i18n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bootWithLocale,
  doInitI18n,
  i18n: i18n$1,
  initI18n,
  setLocale,
  terms,
  useI18n: boundUseI18n
}, Symbol.toStringTag, { value: "Module" }));
export {
  _languages as _,
  initI18n as a,
  bootWithLocale as b,
  doInitI18n as d,
  i18n as i,
  setLocale as s,
  terms as t
};
//# sourceMappingURL=i18n-35335a5c.mjs.map
